import React, { Component } from 'react';

class AjouterRecette extends Component {
    state= {
        nom: '',
        image:'',
        preambule:'',
        texte:'',
        base64:'',
        id:'',
        chef:'',
        date:''
    }
    //Mettre a jour son state
    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        //copier le state
        const recette = {...this.state }
        recette.id = this.props.id;
        recette.chef = this.props.chef;
        recette.date = Date.now();

        //On effectue la fonction créée dans le App
        this.props.ajouterRecette(recette)
        //reset le formulaire
        Object.keys(recette).forEach(item => {
             recette[item] = ''})
        this.setState({ ...recette })
    }

    onFileChange = event => {
        const file = event.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
        this.setState({
            image: file.name,
            base64: reader.result
        });
        }
    }

    render() {
        return (
            <div className="card">
                <form className="admin-form ajouter-recette" onSubmit={this.handleSubmit}>
                    <input value={this.state.nom} onChange={this.handleCHange} name="nom" type="text" placeholder="Nom de l'article"/>
                    <input type="file" onChange={this.onFileChange} /> 

                    <textarea value={this.state.preambule} onChange={this.handleCHange} name="preambule"  rows="3" placeholder="Preambule"/>
                    <textarea value={this.state.texte} onChange={this.handleCHange} name="texte" rows="15" placeholder="Texte de l'article"/>
                    <button type="submit"> Ajouter un article </button>
                </form>
            </div>
        );
    }
}

export default AjouterRecette;